
jQuery(document).ready(function() {

  
//jQuery(".wc-amazon-checkout-message").appendTo("ul.wc_payment_methods");

// jQuery(".wc-amazon-checkout-message").insertBefore(".woocommerce-checkout-payment");


});  // End Document.JQuery





      
  
 


